module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-03-13 at 04.36.48.afb9ba7f.png";